import moment from "moment-timezone";
import { TransText } from ".";
export const LogInfo = ({ log }) => {
  return (<div className="log-time">
    <TransText>Tạo bởi</TransText> <b>{log.created_by ? log.created_by.fullname : ''}</b> <TransText>lúc</TransText> <b>{log.created_at ? moment(log.created_at).format(process.env.REACT_APP_DATETIME_FORMAT) : ''}</b>
  </div>)
}